<template>
  <b-row class="mt-5">
    <div class="col-md-10 offset-md-1 col-lg-8 offset-lg-2">
      <b-card no-body>
        <b-card-header>
          <b-col
            md="12"
            v-if="errors.length > 0"
          >
            <b-alert
              variant="danger"
              :show="errors.length > 0"
            >
              <strong>Ein Fehler ist aufgetreten!</strong>
              <ul v-if="errors.filter(err => err.field).length > 0">
                <li
                  v-for="(error, index) in errors.filter(err => err.field)"
                  :key="index"
                >
                  <strong></strong>{{ error.message }}
                </li>
              </ul>
            </b-alert>
          </b-col>
          <b-col md="12">
            <p v-if="contact">{{ contact.germanGreeting }}</p>
            <p></p>
            <p>
              am <b>{{ startDate }}</b> findet Ihr Inhouse-Seminar
              <b>{{ seminarTitle }}</b> statt. Damit wir Ihrer Firma die
              Schulungsunterlagen, Fachbücher und weitere Materialien
              rechtzeitig zusenden können, benötigen wir die passende
              Versandadresse.
            </p>
            <p></p>
            <p>
              Ihre eingegebenen Daten werden nur zu diesem Zweck genutzt und
              nach der Durchführung der Schulung aus unseren Systemen gelöscht.
            </p>
            <p
              class="popover-subsitute"
              v-if="selectedForm === 'company'"
            >
              Sofern Sie die Unterlagen z.B. in ein Coworking Space oder eine andere Niederlassung senden lassen
              möchten, können Sie die unten stehenden Daten einfach überschreiben.
            </p>
          </b-col>
          <b-col
            md="12"
            v-if="dataReceived === false"
          >
            <b-row>
              <b-col
                lg="5"
                md="6"
                class="mb-4"
              >
                <b-card
                  no-body
                  class="h-100 selectable"
                  :class="{ selected: selectedForm === 'company' }"
                  @click="expandedForm = true; selectedForm = 'company';"
                >
                  <b-card-header>
                    <strong>Firmenadresse verwenden</strong>
                  </b-card-header>
                  <b-card-body>
                    {{ companyAddress.company }}<br />
                    z. Hd. {{ companyAddress.name }}<br />
                    {{ companyAddress.street }}<br />
                    {{ companyAddress.zipCode }} {{ companyAddress.city }}<br />
                    {{ companyAddress.country }}
                    <div
                      class="text-right text-link"
                      v-if="!expandedForm"
                    >
                      <a>ändern <b-icon icon="pencil"></b-icon></a>
                    </div>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col
                lg="5"
                md="6"
                class="mb-4"
              >
                <b-card
                  class="h-100 selectable"
                  :class="{ selected: selectedForm === 'alternate' }"
                  no-body
                  @click="expandedForm = true; selectedForm = 'alternate';"
                >
                  <b-card-header>
                    <strong>Andere Lieferadresse</strong>
                  </b-card-header>
                  <b-card-body :class="{ 'text-center': selectedForm === 'company' && isAlternateAddressEmpty }">
                    <b-icon
                      icon="plus"
                      font-scale="4"
                      class="mt-3"
                      v-if="selectedForm === 'company' && isAlternateAddressEmpty"
                    ></b-icon>
                    <div v-else>
                      {{ alternateAddress.company }}<br />
                      <span v-if="alternateAddress.name">z. Hd. {{ alternateAddress.name }}<br /></span>
                      {{ alternateAddress.street }}<br />
                      {{ alternateAddress.zipCode }} {{ alternateAddress.city }}<br />
                      {{ alternateAddress.country }}
                    </div>
                  </b-card-body>
                </b-card>
              </b-col>
            </b-row>
          </b-col>
        </b-card-header>
        <b-card-body>
          <b-col
            md="12"
            v-if="dataReceived === false"
          >
            <b-form
              class="address-form row"
              @submit.prevent="saveAddress()"
            >
              <b-col
                md="12"
                v-if="expandedForm"
              >
                <b-form-group
                  id="input-group-company"
                  label-for="input-company"
                  class="mb-3"
                >
                  <template slot="label">Firma <span class="font-weight-bold">*</span></template>
                  <b-form-input
                    id="input-company"
                    v-model="inhouseAddress.company"
                    maxlength="100"
                    type="text"
                    required
                    tabindex="0"
                  ></b-form-input>
                </b-form-group>
                <div class="d-none d-sm-block">
                  <b-popover
                    target="input-company"
                    placement="right"
                    triggers="focus"
                  >
                    <template #title>Lieferadresse anpassen</template>
                    Sofern Sie die Unterlagen z.B. in ein Coworking Space oder eine andere Niederlassung senden lassen
                    möchten, können Sie die Firmenadresse einfach überschreiben.
                  </b-popover>
                </div>
              </b-col>
              <b-col
                md="12"
                v-if="expandedForm"
              >
                <b-form-group
                  id="input-group-name"
                  label-for="input-name"
                  class="mb-3"
                >
                  <template slot="label">Zu Händen von <span class="font-weight-bold">*</span></template>
                  <b-form-input
                    id="input-name"
                    v-model="inhouseAddress.name"
                    type="text"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col
                md="12"
                v-if="expandedForm"
              >
                <b-form-group
                  id="input-group-street"
                  label-for="input-street"
                  class="mb-3"
                >
                  <template slot="label">Straße und Hausnummer <span class="font-weight-bold">*</span></template>
                  <b-form-input
                    id="input-street"
                    v-model="inhouseAddress.street"
                    type="text"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col
                md="12"
                v-if="expandedForm"
              >
                <b-row>
                  <b-col md="4">
                    <b-form-group
                      id="input-group-zip-code"
                      label-for="input-zip-code"
                      class="mb-3"
                    >
                      <template slot="label">Postleitzahl <span class="font-weight-bold">*</span></template>
                      <b-form-input
                        id="input-zip-code"
                        v-model="inhouseAddress.zipCode"
                        type="text"
                        required
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="8">
                    <b-form-group
                      id="input-group-city"
                      label-for="input-city"
                      class="mb-3"
                    >
                      <template slot="label">Ort <span class="font-weight-bold">*</span></template>
                      <b-form-input
                        id="input-city"
                        v-model="inhouseAddress.city"
                        type="text"
                        required
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
              <b-col
                md="12"
                v-if="expandedForm"
              >
                <b-form-group
                  id="input-group-country"
                  label-for="input-country"
                  class="mb-3"
                >
                  <template slot="label">Land <small class="text-muted">(optional)</small></template>
                  <b-form-input
                    id="input-country"
                    v-model="inhouseAddress.country"
                    type="text"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col
                md="12"
                v-if="expandedForm"
                class="mb-4"
              >
                <b-form-group role="group">
                  <template slot="label">
                    E-Mail-Adresse zur Paketverfolgung <small class="text-muted">(optional)</small>
                  </template>
                  <b-form-input
                    id="input-email"
                    v-model="inhouseAddress.email"
                    type="text"
                  ></b-form-input>
                  <b-popover
                    target="input-email"
                    placement="right"
                    triggers="focus"
                  >
                    <template #title>Möchten Sie Ihr Paket verfolgen?</template>
                    Sofern Sie Informationen zur Zustellung Ihres Pakets mit den Schulungsunterlagen per E-Mail durch
                    DHL erhalten möchten, tragen Sie bitte Ihre E-Mail-Adresse ein. Wir verwenden die hier angegebene
                    E-Mail-Adresse nur einmalig und nur zu diesem Zweck. Mit der Angabe Ihrer E-Mail-Adresse erklären
                    Sie sich mit einer Weitergabe an DHL einverstanden.
                  </b-popover>
                </b-form-group>
              </b-col>

              <b-col md="12">
                <p>
                  Wir senden Ihnen auf Wunsch ein Paket mit Schulungsunterlagen,
                  Fachbüchern und weiteren Materialien für Ihr Inhouse-Seminar zu.
                </p>
                <div>
                  <b-form-checkbox
                    id="checkbox-packet"
                    v-model="packet"
                    name="checkbox-packet"
                    unchecked-value="0"
                    value="1"
                    class="mr-3 mb-3 cursor-pointer"
                    switch
                  >
                    &nbsp;Ich möchte ein <b>Materialpaket</b> erhalten
                  </b-form-checkbox>
                </div>
              </b-col>
              <b-col>
                <div class="clearfix">
                  <b-button
                    class="float-right btn-cta"
                    type="submit"
                    variant="primary"
                  >
                    Abschicken
                  </b-button>
                </div>
              </b-col>
            </b-form>
          </b-col>

          <b-row v-if="dataReceived === true">
            <b-col
              class="text-center mt-3 mb-5"
              md="12"
            >
              <p class="text-success mb-5"><strong>Wir haben Ihre Daten erhalten. Dankeschön.</strong></p>
              <p><b>Versandadresse:</b></p>
              <p>
                {{ inhouseAddress.company }}<br>
                z. Hd. {{ inhouseAddress.name }}<br>
                {{ inhouseAddress.street }}<br>
                {{ inhouseAddress.zipCode }} {{ inhouseAddress.city }}
                <span v-if="inhouseAddress.country"><br>{{ inhouseAddress.country }}</span><br>
                <span v-if="inhouseAddress.email">{{ inhouseAddress.email }}</span>
              </p>
              <p><b>Materialpaket:</b></p>
              <p>
                <strong
                  class="text-success"
                  v-if="parseInt(packet) === 1"
                ><b-icon
                    icon="check-circle-fill"
                    style="font-weight:bolt"
                  ></b-icon> Ja</strong>
                <strong
                  class="text-danger"
                  v-else
                ><b-icon icon="x-circle-fill"></b-icon> Nein</strong>
              </p>
            </b-col>
            <b-col
              md="12"
              class="text-right "
            >
              <b-button
                type="default"
                @click="dataReceived = false"
              ><b-icon
                  icon="arrow-left"
                  style="margin-bottom:-1.5px"
                ></b-icon>&nbsp;zurück zum Formular</b-button>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </div>
  </b-row>
</template>

<script>
import axios from "axios";

export default {
  name: "InhouseAddressForm",
  props: {
    seminarDateHashId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      API_URL: process.env.VUE_APP_API_URL || "https://api.gfu.cloud",
      inhouseSeminar: null,
      inhouseAddress: {},
      companyAddress: {},
      alternateAddress: {},
      packet: 1,
      success: null,
      errors: [],
      selectedForm: "company",
      dataReceived: false,
      expandedForm: false,
    };
  },
  mounted() {
    axios
      .get(
        `${this.API_URL}/api/inhouse-addresses/${this.seminarDateHashId}/by-hash`
      )
      .then((resp) => {
        this.inhouseSeminar = resp.data;
        this.inhouseAddress = {
          company: this.companyName,
          name: this.contactName,
          street: this.companyStreet,
          zipCode: this.companyZipCode,
          city: this.companyCity,
          country: this.country,
          email: this.contactEmail,
        };

        this.setCompanyAddress();
        this.alternateAddress = {
          company: "",
          name: "",
          street: "",
          zipCode: "",
          city: "",
          country: "",
          email: this.contactEmail,
        };
      })
      .catch((error) => {
        if (error.response && error.response.status === 404) {
          this.errors.push({
            field: 'hash',
            message: error.response.data.message
          });
        } else {
          this.errors = [error];
        }
      });
  },
  methods: {
    saveAddress() {
      const payload = {
        company: this.inhouseAddress.company,
        name: this.inhouseAddress.name,
        street: this.inhouseAddress.street,
        zipCode: this.inhouseAddress.zipCode,
        city: this.inhouseAddress.city,
        country: this.inhouseAddress.country ? this.inhouseAddress.country : null,
        email: this.inhouseAddress.email ? this.inhouseAddress.email : null,
        packet: parseInt(this.packet),
      };

      axios
        .post(
          `${this.API_URL}/api/inhouse-addresses/${this.seminarDateHashId}/by-hash`,
          payload,
        )
        .then(() => {
          this.success = true;
          this.errors = [];
          this.dataReceived = true;
        })
        .catch((error) => {
          if (error.response && error.response.status === 422) {
            this.errors = error.response.data;
          } else {
            this.errors = [error];
          }
          window.scrollTo(0, 0);
          this.success = false;
        });

      return true;
    },
    dateToLocalString(dateString) {
      const startDate = new Date(dateString);
      return startDate.toLocaleDateString("de-DE", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
      });
    },
    setInhouseAddress(address) {
      this.inhouseAddress = address;
    },
    setCompanyAddress() {
      this.companyAddress = this.inhouseAddress;
    },
    setAlternateAddress() {
      this.alternateAddress = this.inhouseAddress;
    },
  },
  computed: {
    contact() {
      return this.inhouseSeminar && this.inhouseSeminar.order
        ? this.inhouseSeminar.order.contact
        : null;
    },
    company() {
      return this.contact ? this.contact.company : null;
    },
    contactName() {
      return this.contact
        ? this.contact.firstName + " " + this.contact.lastName
        : "";
    },
    contactEmail() {
      return this.contact ? this.contact.email : "";
    },
    startDate() {
      return this.inhouseSeminar
        ? this.dateToLocalString(this.inhouseSeminar.startDate)
        : "";
    },
    seminarTitle() {
      return this.inhouseSeminar ? this.inhouseSeminar.seminarTitle : "";
    },
    companyName() {
      return this.company ? this.company.company : "";
    },
    companyStreet() {
      return this.company ? this.company.street : "";
    },
    companyZipCode() {
      return this.company ? this.company.zipCode : "";
    },
    companyCity() {
      return this.company ? this.company.city : "";
    },
    country() {
      return this.company ? this.company.country : "";
    },
    isAlternateAddressEmpty() {
      return !this.alternateAddress.company &&
        !this.alternateAddress.street &&
        !this.alternateAddress.zipCode &&
        !this.alternateAddress.city &&
        !this.alternateAddress.country;
    },
  },
  watch: {
    selectedForm(newVal, oldVal) {
      if (oldVal === "company") this.setCompanyAddress();
      if (oldVal === "alternate") this.setAlternateAddress();

      if (newVal === "company") {
        this.setInhouseAddress(this.companyAddress);
      }
      if (newVal === "alternate") {
        this.setInhouseAddress(this.alternateAddress);
      }
    },
  },
};
</script>

<style scoped>
.float-right {
  float: right;
}

.btn-cta {
  color: #fff;
  background-color: #f77635;
  border-color: #f77635;
  box-shadow: rgb(108 117 125 / 40%) 3px 3px 10px;
}

.btn-cta:hover,
.btn-cta:active,
.btn-cta:focus {
  color: #fff;
  background-color: #f65d10;
  border-color: #f05709;
  box-shadow: rgb(108 117 125 / 40%) 3px 3px 10px, 0 0 0 0.2rem rgb(248 139 83 / 50%);
}

.card .card {
  box-shadow: none !important;
  padding: 0px;
}

.card .card-header .card .card-header,
.card .card-header .card .card-body {
  padding: 1em;
}

.card.selectable {
  cursor: pointer;
}

.card.selectable.selected,
.card.selectable:hover {
  border-color: #bbb;
}

.card.selectable:hover .card-header {
  background: #266cb4;
  color: white;
  margin-left: -1px;
  margin-right: -1px;
  margin-top: -1px;
  border-top: 1px solid #266cb4;
}

.card.selectable:hover {
  opacity: 0.8;
}

.card.selectable.selected:hover .card-header,
.card.selectable.selected .card-header {
  background: #266cb4;
  color: white !important;
  margin-left: -1px;
  margin-right: -1px;
  margin-top: -1px;
  border-top: 1px solid #266cb4;
}

.card.selectable.selected:hover {
  opacity: 1;
}

.card.selectable .card-header {
  background: #e9ecef;
}

.card.selectable .card-header,
.card.selectable .card-body {
  color: #777;
}

.card.selectable.selected .card-header,
.card.selectable.selected .card-body {
  color: inherit;
}

.text-link {
  color: #999;
  position: absolute;
  right: 5px;
  bottom: 1px;
  font-size: 1em;
}

.card.selectable:hover .text-link {
  color: #004c94;
}

@media (max-width: 1330px) {
  .popover.b-popover {
    display: none;
  }
}

@media (min-width: 1331px) {
  .popover-subsitute {
    display: none;
  }
}
</style>

<style>
.cursor-pointer input {
  cursor: pointer;
}

.cursor-pointer label {
  cursor: pointer;
}
</style>
